import { API_ENDPOINTS } from '../../../api/endpoints';
export class AcceptedGrantsAPI {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    async fetchGrantStatistics(grant_id) {
        return this.apiClient.get(API_ENDPOINTS.ACCEPTED_GRANTS.STATISTICS(grant_id));
    }
    async fetchAcceptedApplications(grant_id, limit, offset, industry, region, revenue, size) {
        return this.apiClient.get(API_ENDPOINTS.ACCEPTED_GRANTS.ACCEPTED_APPLICATIONS(grant_id, limit, offset, industry, region, revenue, size));
    }
    async fetchFundingIntelligenceStatistics(locale, limit, page, industry, region, revenue, size, query) {
        return this.apiClient.get(API_ENDPOINTS.ACCEPTED_GRANTS.FUNDING_INTELLIGENCE_STATISTICS(locale, limit, page, industry, region, revenue, size, query));
    }
    async fetchFundingIntelligenceCompetition(locale, limit, page, industry, region, revenue, size, query) {
        return this.apiClient.get(API_ENDPOINTS.ACCEPTED_GRANTS.FUNDING_INTELLIGENCE_COMPETITION(locale, limit, page, industry, region, revenue, size, query));
    }
}
